import { createIcon } from "@chakra-ui/icons";

const Bookmark = createIcon({
  displayName: "Bookmark",
  viewBox: "0 0 24 24",
  path: [
    <path
      d="M5 7.8C5 6.11984 5 5.27976 5.32698 4.63803C5.6146 4.07354 6.07354 3.6146 6.63803 3.32698C7.27976 3 8.11984 3 9.8 3H14.2C15.8802 3 16.7202 3 17.362 3.32698C17.9265 3.6146 18.3854 4.07354 18.673 4.63803C19 5.27976 19 6.11984 19 7.8V21L12 17L5 21V7.8Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      key="CHA-"
    ></path>,
  ],
  defaultProps: { boxSize: 4 },
});

export default Bookmark;
